import { createReducer, on } from '@ngrx/store';
import { LoadStatus } from 'src/app/core/enums/load-status.enum';
import { DukeUser } from '../../../../admin/data-access/models/duke-user.model';
import { DukeUsersAPIActions } from './actions';

export interface DukeUsersState {
  dukeUsers: DukeUser[];
  _ui: {
    status: LoadStatus;
    isSubmitting: boolean;
  };
}

const initialState: DukeUsersState = {
  dukeUsers: [],
  _ui: {
    status: LoadStatus.NOT_LOADED,
    isSubmitting: false,
  },
};

export const dukeUsersReducer = createReducer<DukeUsersState>(
  initialState,
  on(
    DukeUsersAPIActions.updateDukeUserSuccess,
    (state, action): DukeUsersState => {
      return {
        ...state,
        dukeUsers: action.dukeUsers,
        _ui: {
          status: LoadStatus.LOADED,
          isSubmitting: false,
        },
      };
    }
  ),
  on(DukeUsersAPIActions.updateDukeUserFail, (state): DukeUsersState => {
    return {
      ...state,
      _ui: {
        status: LoadStatus.NOT_LOADED,
        isSubmitting: true,
      },
    };
  })
);
